"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M15 1H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM4 13H2V3h2v10zm3 0H5V3h2v10zm7 0H8V3h6v10z"];
//# sourceMappingURL=column-layout.js.map